module.exports = __webpack_public_path__ + "img/logo.c45a7765.svg";